(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('kiddil-film')) return;
  class KiddilFilm extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var video = this.querySelector('video');
      var controls = this.querySelector('[data-film-controls]');
      if (video) this._lazyPoster(video);
      if (!video || !controls) return;
      this._ready = true;
      this._removeListeners = [];
      var play = this.querySelector('[data-film-play]');
      var sound = this.querySelector('[data-film-sound]');
      var playLabel = this.querySelector('[data-film-play-label]');
      var soundLabel = this.querySelector('[data-film-sound-label]');
      var status = this.querySelector('[data-film-status]');
      var direct = this.querySelector('[data-film-direct]');
      var media = window.matchMedia('(prefers-reduced-motion: reduce)');
      var autoAttempted = false;
      var userStarted = false;
      var visible = false;
      var self = this;
      function on(target, event, handler) {
        target.addEventListener(event, handler);
        self._removeListeners.push(function () { target.removeEventListener(event, handler); });
      }
      function sync() {
        var playing = !video.paused && !video.ended;
        var label = playing ? self.dataset.pauseLabel : self.dataset.playLabel;
        self.dataset.playing = String(playing);
        self.dataset.muted = String(video.muted);
        playLabel.textContent = label;
        play.setAttribute('aria-label', label);
        if (sound && soundLabel) {
          label = video.muted ? self.dataset.unmuteLabel : self.dataset.muteLabel;
          soundLabel.textContent = label;
          sound.setAttribute('aria-label', label);
        }
      }
      function showFailure() {
        status.textContent = self.dataset.errorLabel;
        status.hidden = false;
        direct.hidden = false;
        sync();
      }
      function start(manual) {
        status.hidden = true;
        direct.hidden = true;
        try {
          var result = video.play();
          if (result && typeof result.catch === 'function') result.catch(function () {
            if (manual) showFailure();
            else sync();
          });
        } catch (error) {
          if (manual) showFailure();
          else sync();
        }
      }
      function togglePlay() {
        autoAttempted = true;
        if (video.paused || video.ended) {
          userStarted = true;
          start(true);
        } else video.pause();
      }
      function maybeAutoplay() {
        if (self.dataset.autoplay !== 'true' || autoAttempted || !visible || document.hidden || media.matches || (navigator.connection && navigator.connection.saveData)) return;
        autoAttempted = true;
        video.muted = true;
        start(false);
      }
      on(play, 'click', togglePlay);
      if (sound) on(sound, 'click', function () { video.muted = !video.muted; sync(); });
      ['play', 'pause', 'ended', 'volumechange'].forEach(function (event) { on(video, event, sync); });
      on(video, 'error', function () { controls.hidden = true; video.controls = true; showFailure(); });
      on(document, 'visibilitychange', function () {
        if (document.hidden) video.pause();
        else maybeAutoplay();
      });
      function motionChanged() { if (media.matches && !userStarted) video.pause(); }
      if (media.addEventListener) on(media, 'change', motionChanged);
      else if (media.addListener) {
        media.addListener(motionChanged);
        this._removeListeners.push(function () { media.removeListener(motionChanged); });
      }
      video.muted = true;
      video.defaultMuted = true;
      sync();
      controls.hidden = false;
      video.controls = false;
      this.setAttribute('data-enhanced', '');
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          if (!visible) video.pause();
          else maybeAutoplay();
        }, {threshold:0.25});
        this._observer.observe(video);
      }
      this._video = video;
    }
    // The poster ships as data-posters ("url 720w, url 1280w, ...") rather than
    // a poster attribute, which the browser fetches at parse time however far
    // down the page the player is. It is set as the section comes within about
    // a screen of the viewport, at the smallest width that covers the player.
    _lazyPoster(video) {
      var list = video.getAttribute('data-posters');
      if (!list || video.getAttribute('poster')) return;
      var el = this;
      function apply() {
        if (el._posterObserver) { el._posterObserver.disconnect(); el._posterObserver = null; }
        var need = (video.clientWidth || el.clientWidth || window.innerWidth) * (window.devicePixelRatio || 1);
        var pick = null;
        list.split(',').forEach(function (entry) {
          var parts = entry.trim().split(/\s+/);
          var width = parseInt(parts[1], 10);
          if (!parts[0] || !width) return;
          if (!pick || (pick.width < need && width > pick.width) || (width >= need && width < pick.width)) pick = { url: parts[0], width: width };
        });
        if (pick) video.poster = pick.url;
      }
      if (!('IntersectionObserver' in window)) { apply(); return; }
      this._posterObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) apply();
      }, { rootMargin: '100% 0px' });
      this._posterObserver.observe(this);
    }
    disconnectedCallback() {
      if (this._posterObserver) this._posterObserver.disconnect();
      if (this._observer) this._observer.disconnect();
      if (this._video) { this._video.pause(); this._video.controls = true; }
      (this._removeListeners || []).forEach(function (remove) { remove(); });
      this._ready = false;
    }
  }
  window.customElements.define('kiddil-film', KiddilFilm);
})();
